import React from "react";
import { useLogin } from "@refinedev/core";
import { Card, Form, Input, Button, Typography, Layout } from "antd";

type LoginVars = { username: string; access_key: string };

export const LoginPage: React.FC = () => {
  const { mutate: login, isLoading } = useLogin<LoginVars>();

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f0f2f5",
      }}
    >
      <Card style={{ width: 360 }}>
        <Typography.Title level={4} style={{ textAlign: "center" }}>
          Flywheel AI Portal
        </Typography.Title>
        <Form<LoginVars> layout="vertical" onFinish={(values) => login(values)}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true }]}
          >
            <Input autoComplete="username" />
          </Form.Item>
          <Form.Item
            label="Access key"
            name="access_key"
            rules={[{ required: true }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={isLoading}>
            Sign in
          </Button>
        </Form>
      </Card>
    </Layout>
  );
};
